const React = require('react');

const IntervalFilterConstructor = require('../IntervalFilterConstructor');

const Button = require('./components/IntervalBtn');
const SearchFilterMerchant = require('./components/SearchFilterMerchant');
const SelectFilterMerchant = require('./components/SelectFilterMerchant');
const IntervalFilterBlock = require("./components/IntervalFilterBlock");

// const {BtnTableGlobalRefresh, BtnTableGlobalDownload} = require("../../../AdminHelpers/Buttons");

const BtnTableGlobalRefresh = require('./components/BtnTableGlobalRefresh');
const BtnTableGlobalPrint = require('./components/BtnTableGlobalPrint');
const BtnTableGlobalDownload = require('./components/BtnTableGlobalDownload');

const IntervalFilterMerchant = ({className, update, report, ...props}) => {
  const reportTypes = ((report || {}).types || []);
  return (
    <IntervalFilterConstructor
      {...props}
      className={"mh-3 pt10 pb10 (lt|mb10|ph3)>1 " + className}
      TimeIntervalsComponent={IntervalFilterBlock}
      searchComponent={SearchFilterMerchant}
      selectComponent={SelectFilterMerchant}
      additionalComponents={(
        <div className="mlAuto layoutRow mh-3 (mb10|ph3)>1">
          {!!update && (
            <div>
              <BtnTableGlobalRefresh
                update={update}
              />
            </div>
          )}
          {reportTypes.includes('csv') && (
            <div>
              <BtnTableGlobalDownload
                filter={props.data}
                report={report}
                type="csv"
              />
            </div>
          )}
          {reportTypes.includes('pdf') && (
            <div>
              <BtnTableGlobalDownload
                filter={props.data}
                report={report}
                type="pdf"
              />
            </div>
          )}
        </div>
      )}
    />
  );
}

module.exports = IntervalFilterMerchant;
